import {Component, OnInit, ViewChild} from '@angular/core';
import {AppointmentService} from '../../appointment/services/appointment.service';
import {Toast} from 'primeng/toast';
import {Appointment} from '../../appointment/data/appointment';
import {UserService} from '../../user/services/user/user.service';
import {AppStateService, AppWindowState} from '../../app-common/services/appState/app-state.service';
import {AppointmentDto} from '../../appointment/data/appointmentDto';
import {LoggerService} from '../../logging/services/logger.service';
import {LogLevel} from '../../logging/data/logLevel';
import {LogSourceType} from '../../logging/data/logSourceType';
import {LogSource} from '../../logging/data/logSource';
import {SignalRService} from '../../app-common/services/signalr/signal-r.service';

@Component({
  selector: 'w-appointment-notifications-holder',
  templateUrl: './appointment-notifications-holder.component.html',
  styleUrls: ['./appointment-notifications-holder.component.scss']
})
export class AppointmentNotificationsHolderComponent implements OnInit {
  @ViewChild('toast') toast: Toast;

  appointments: AppointmentDto[] = [];

  constructor(private appStateService: AppStateService,
              private appointmentService: AppointmentService,
              private userService: UserService,
              private signalRService: SignalRService,
              private loggingService: LoggerService) {
  }

  ngOnInit() {
    this.getAllAppointmentsWorthToRemind();
    this.subscribeToAppointmentChanges();
  }

  addAppointment(appointment: Appointment): void {
    this.appointmentService.getAppointmentById(appointment.id).then(result => {
      this.addAppointmentDto(result);
    });
  }

  addAppointmentDto(appointment: AppointmentDto): void {
    this.appointments.push(appointment);
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.AppointmentNotification, `Appointment ${appointment.appointment.id} added to list`);
  }

  updateAppointment(appointment: Appointment): void {
    this.appointmentService.getAppointmentById(appointment.id).then(result => {
      this.updateAppointmentDto(result);
    });
  }

  updateAppointmentDto(appointment: AppointmentDto): void {
    const existing = this.appointments.find(x => x.appointment.id === appointment.appointment.id);
    existing.appointment = appointment.appointment;
    existing.appointmentContacts = appointment.appointmentContacts;
    existing.additionalCustomers = appointment.additionalCustomers;
    existing.additionalUsers = appointment.additionalUsers;
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.AppointmentNotification, `Appointment ${appointment.appointment.id} updated in list`);
  }

  removeAppointment(id: number): void {
    const index = this.appointments.findIndex(x => x.appointment.id === id);
    if (index > -1) {
      this.appointments.splice(index, 1);
      this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.AppointmentNotification, `Appointment ${id} removed from list`);
    } else {
      this.loggingService.logMessage(LogLevel.ERROR, LogSourceType.COMPONENT, LogSource.AppointmentNotification, `Appointment ${id} not found in list`);
    }
  }


  private getAllAppointmentsWorthToRemind(): void {
    this.appStateService.appWindowStateChange.subscribe(result => {
      if (result.previousValue === AppWindowState.Loading && result.currentValue === AppWindowState.Main) {
        this.userService.fetchCurrentUser().then(() => {
          this.getAppointmentsForToday();
        });
      }
    });
  }

  async getAppointmentsForToday(){
    const appointments = await this.appointmentService.getAllAppointmentsWorthToRemind();
    if (appointments.length > 0){
      for (const dto of appointments){
        this.addAppointmentDto(dto);
      }
    }
  }

  subscribeToAppointmentChanges(): void {
    this.signalRService.appointmentHandler.onReceive.subscribe(result => {
      const existing = this.appointments.find(x => x.appointment.id === result.id);
      if (existing) {
        this.updateAppointment(result);
      } else {
        this.addAppointment(result);
      }
    });
  }
}
